// extracted by mini-css-extract-plugin
export default {"discription":"instruction_discription__CaCGd","warning":"instruction_warning__AOKh1","rodo":"instruction_rodo__qI8mz","linkActive":"instruction_linkActive__bywG-"};